import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];
export const MASK_EASE = [0.76, 0, 0.24, 1];

// Scroll-triggered fade + rise. Fires once when it enters the viewport.
export const Reveal = ({ children, delay = 0, y = 40, className, as, ...rest }) => {
  const Comp = as ? motion[as] : motion.div;
  return (
    <Comp
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-90px" }}
      transition={{ duration: 0.8, ease: EASE, delay }}
      className={className}
      {...rest}
    >
      {children}
    </Comp>
  );
};

// Masked line-by-line reveal for kinetic hero headlines.
export const MaskLine = ({ children, delay = 0, className }) => (
  <span className="block overflow-hidden pb-[0.08em]">
    <motion.span
      className={`block ${className || ""}`}
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.15, ease: MASK_EASE, delay }}
    >
      {children}
    </motion.span>
  </span>
);
